import React from 'react';
import { BoxV2 as Box, Flex, SxProps } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export interface CheckboxProps {
  label?: React.ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  'data-testid'?: string;
  sx?: SxProps;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled,
  'data-testid': testId,
  sx,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <Flex
      sx={{
        alignItems: 'flex-start',
        cursor: disabled ? 'not-allowed' : 'pointer',
        gap: '8px',
        opacity: disabled ? 0.5 : 1,
        userSelect: 'none',
        ...sx,
      }}
      onClick={handleClick}
      data-testid={testId}
    >
      <Box
        sx={{
          width: '15px',
          height: '15px',
          borderRadius: '2px',
          border: '1.5px solid',
          borderColor: disabled ? '#CCCFD0' : '#808789',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          position: 'relative',
          flexShrink: 0,
          mt: '2px',
        }}
      >
        {checked && (
          <Box
            sx={{
              color: '#0091B3',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FontAwesomeIcon icon={faCheck} />
          </Box>
        )}
      </Box>
      {label && (
        <Box
          sx={{
            fontSize: '14px',
            fontWeight: '400', // Checkbox label usually normal weight in design
            color: '#4d5659', // secondary text color
            lineHeight: '1.4',
          }}
        >
          {label}
        </Box>
      )}
    </Flex>
  );
};

export default Checkbox;
